import React from "react";
import { FormSectionElements, FormSections, FormSubSections, LOVValues, ProgramContainer } from "../../entities/formTemplateDataType";
import { buttonClassList, SubmissionMethodList } from "../../entities/Constants";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { generateSectionIndex } from "../../utilities/ElementUtils";
interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;
}

interface State {
    pickedFieldOptions;
}

export class DialogForButtonComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
        };
    }

    componentDidMount(): void {
        if (this.props.ele.FilterField != null) {
            this.onChangeHanlder(this.props.ele.FilterField)
        }
    }


    onChangeHanlder = (newValue) => {
        this.props.ele.FilterField = newValue;
        let totalOption = [];
        let eleList = (this.props.ele.parent as FormSubSections).ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence)
        let pickedFieldOptions =  eleList.filter(
                    (ele) =>
                        this.props.isEng
                            ? ele.ENUTitle.replace(/\s/g, "") === newValue
                            : ele.FRATitle.replace(/\s/g, "") === newValue
                ).map((q) => {
                    const container = {};
                    container[
                        this.props.isEng
                            ? q.ENUTitle.replace(/\s/g, "")
                            : q.FRATitle.replace(/\s/g, "")
                    ] = q.ListOfLOVValues;
                    return container;
                });

                totalOption.push(...pickedFieldOptions);


        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    generateContentString = () => {
        let elementListWithOptions = [];
        const sectionIndex = generateSectionIndex(this.props.ele)

        let subSection = this.props.ele.parent as FormSubSections;
        let list = subSection.ListOfFormSectionElements.filter(
            (q) =>
            (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown")
        ).map((q) => {
            return {
                code: this.props.isEng
                    ? q.ENUTitle?.replace(/\s/g, "")
                    : q.FRATitle?.replace(/\s/g, ""),
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });
        elementListWithOptions.push(...list);

        const valueArray = Array.isArray(this.props.ele.ClassName) ? this.props.ele.ClassName : [];

        let htmlString = [];
        htmlString.push(
            <div style={{ width: "100%", paddingTop: "5px" }}>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            options={elementListWithOptions}
                            className="ontario-dropdown-small"
                            optionLabel="description"
                            optionValue="code"
                            value={this.props.ele.FilterField?.replace(/\s/g, "")}
                            placeholder="Filtered by previous field"
                            onChange={(e) => {
                                this.onChangeHanlder(e.value);
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            className="ontario-dropdown-small"
                            options={this.state.pickedFieldOptions[0] != null ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
                            value={this.props.ele.FilterValue}
                            optionLabel="description"
                            optionValue="code"
                            placeholder="Filtering value"
                            onChange={(e) => {
                                this.props.isEng ? (this.props.ele.FilterValue = e.value) : (this.props.ele.FilterValueFRA = e.value);
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Stepper Script</div>
                    <div style={{ width: '60%'}}>                  
                    <InputTextarea className="ontario-input" 
                     value={this.props.ele.StepperScript} onChange={(e) => {
                        this.props.ele.StepperScript = e.target.value;
                        this.props.callback();
                    }}></InputTextarea></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Init Script</div>
                    <div style={{ width: '60%'}}>                  
                    <InputTextarea className="ontario-input" 
                     value={this.props.ele.InitScript} onChange={(e) => {
                        this.props.ele.InitScript = e.target.value;
                        this.props.callback();
                    }}></InputTextarea></div>
                </div>


                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%'}}>                  
                    <InputTextarea className="ontario-input" 
                     value={this.props.ele.Script} onChange={(e) => {
                        this.props.ele.Script = e.target.value;
                        this.props.callback();
                    }}></InputTextarea></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Class(es)</div>
                    <div style={{ width: '60%' }}>
                        <MultiSelect key={"class_button_" + this.props.ele.Sequence}
                            options={buttonClassList}
                            optionLabel='label'
                            optionValue='val'
                            value={valueArray}
                            onChange={(e) => {
                                this.props.ele.ClassName = e.value;
                                this.props.callback();
                            }}></MultiSelect >
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Inline (Styling):</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.inlineStyling} value={this.props.ele.inlineStyling}
                            className='p-checkbox' title="Button is inline without line break"
                            onChange={(e) => {
                                this.props.ele.inlineStyling = e.checked;
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Validate Step</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.ValidateStep == 'Y'} value={this.props.ele.ValidateStep}
                            className='p-checkbox' title="Validate Step where button is"
                            onChange={(e) => {
                                this.props.ele.ValidateStep = e.checked ? 'Y' : 'N';
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Recaptcha</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={!!this.props.ele.Recaptcha} value={!!this.props.ele.Recaptcha}
                            className='p-checkbox' title="Enable Recaptcha"
                            onChange={(e) => {
                                this.props.ele.Recaptcha = e.checked ? {action: ''} : undefined;
                                this.props.callback();
                            }} />
                    </div>
                </div>
                { this.props.ele.Recaptcha && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Recaptcha action:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input" 
                                value={this.props.ele.Recaptcha.action} 
                                onChange={(e) => {
                                    this.props.ele.Recaptcha.action = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API</div>
                    <div style={{ width: '60%'}}>                  
                    <InputText className="ontario-input" 
                        value={this.props.ele.Api} 
                        onChange={(e) => {
                            this.props.ele.Api = e.target.value;
                            this.props.callback();
                        }}
                    />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Method</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            className="ontario-dropdown-small"
                            options={SubmissionMethodList}
                            value={this.props.ele.SubmissionMethod}
                            optionLabel='label'
                            optionValue='val'
                            placeholder="SubmissionMethod"
                            onChange={(e) => {
                                this.props.ele.SubmissionMethod = e.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                { this.props.ele.Api && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API error redirect to:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            {/* @ts-ignore */}
                            <Dropdown style={{ width: '100%' }} showClear
                                className="ontario-dropdown-small"
                                options={sectionIndex}
                                value={this.props.ele.SubmissionMethod}
                                optionLabel='title'
                                optionValue='sequence'
                                placeholder="Page to redirect to"
                                onChange={(e) => {
                                    const sequence = Number(e.value)
                                    this.props.ele.apiErrorRedirectPage = isNaN(sequence) ? undefined : sequence;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
             </div>);

        return htmlString;
    };

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Button properties for " + this.props.ele.ENUTitle : "Section properties for" + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.generateContentString()}
                </Dialog>
            </>
        );
        return html;
    }


    render() {

        return (
            <div>
                {this.generateHtmlString()}
            </div>
        );
    }
}
